module.exports = __webpack_public_path__ + "static/media/iconfinder_m-28_4230541.c45a2a71.svg";